export default {"src":"/_next/static/media/ownspace-logo.d6eeb365.svg","height":20,"width":114,"blurWidth":0,"blurHeight":0};